//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../axios/axios.js'
import ImageViewer from '../../../components/Images/ImageViewer.vue'

export default {
  components: {
    ImageViewer
  },
  props: {
    toolKey: {
      type: String,
      default: null
    }
  },
  methods: {
    onOpenImage: function (toolKey) {
      if (!toolKey) {
        this.$q.notify({
          type: 'warning',
          message: 'Фото материала отсутствует',
          progress: true,
          timeout: 8000
        })

        return
      }

      axiosGet({
        url: 'service/delta/report/toolPhoto/' + toolKey,
        onSuccess: (response) => {
          return response
        },
        onFailure: 'Ошибка получения фото',
        msgTarget: this
      }).then((response) => {
        const imagesInfo = response.data.result
        const images = []
        if (imagesInfo && imagesInfo.length) {
          for (let i = 0; i < imagesInfo.length; i++) {
            images.push({
              document: imagesInfo[i],
              url: '/service/delta/document/read?id=' + imagesInfo[i].id,
              name: imagesInfo[i].name
            })
          }

          this.openImages(images, 0)
        } else {
          this.$q.notify({
            type: 'warning',
            message: 'Фото материала отсутствует',
            progress: true,
            timeout: 8000
          })
        }
      })
    },
    openImages: function (files) {
      this.$refs.viewer.show(files, 0)
    }
  }
}

